export interface Movie {
  id: string;
  title: string;
  originalTitle: string;
  year: number;
  category: string;
  categorySlug: string;
  rating: number;
  duration: string;
  region: string;
  director: string;
  actors: string[];
  description: string;
  descriptionHtml: string;
  posterUrl: string;
  coverUrl: string;
  isHot: boolean;
  isNew: boolean;
  isFeatured: boolean;
  tags: string[];
  releaseDate: string;
}

export interface MovieCategory {
  name: string;
  slug: string;
  icon: string;
  count: number;
  description: string;
}

export const movieCategories: MovieCategory[] = [
  { name: '动作片', slug: 'action', icon: 'ri-sword-line', count: 28, description: '热血沸腾的动作大片，拳拳到肉的精彩对决' },
  { name: '喜剧片', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 22, description: '爆笑不断的喜剧佳作，欢乐治愈每一刻' },
  { name: '科幻片', slug: 'scifi', icon: 'ri-rocket-line', count: 18, description: '脑洞大开的科幻巨制，探索未知宇宙世界' },
  { name: '爱情片', slug: 'romance', icon: 'ri-heart-line', count: 15, description: '甜蜜浪漫的爱情故事，感动人心的情感之旅' },
  { name: '恐怖片', slug: 'horror', icon: 'ri-ghost-line', count: 12, description: '惊悚刺激的恐怖体验，挑战你的心理极限' },
  { name: '动画片', slug: 'animation', icon: 'ri-movie-line', count: 20, description: '精彩绝伦的动画世界，适合全家人共同观看' },
  { name: '战争片', slug: 'war', icon: 'ri-shield-flash-line', count: 10, description: '震撼人心的战争史诗，铭记历史致敬英雄' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line', count: 16, description: '真实纪录的精彩故事，探索世界的每一个角落' },
];

export const movies: Movie[] = [
  {
    id: 'movie-1',
    title: '战狼3：使命召唤',
    originalTitle: 'Wolf Warrior 3: Call of Duty',
    year: 2026,
    category: '动作片',
    categorySlug: 'action',
    rating: 8.7,
    duration: '128分钟',
    region: '中国大陆',
    director: '吴京',
    actors: ['吴京', '张译', '李晨', '余男'],
    description: '冷锋接到一项秘密任务，需要深入战乱地区解救被困的中国公民。面对重重危险，他凭借过人的战斗技巧和坚定信念，与恐怖分子展开了一场惊心动魄的生死较量。本片延续了战狼系列的硬核动作风格，场面更加宏大震撼。',
    descriptionHtml: '<p>冷锋接到一项秘密任务，需要深入战乱地区解救被困的中国公民。面对重重危险，他凭借过人的战斗技巧和坚定信念，与恐怖分子展开了一场惊心动魄的生死较量。</p><p>本片延续了战狼系列的硬核动作风格，场面更加宏大震撼，动作设计更加精妙，不仅有激烈的枪战场面，还有令人窒息的近身格斗和惊险的追逐戏码。</p><p>影片在全球多地取景拍摄，制作规模达到华语电影新高度，是2026年最受期待的动作大片。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20action%20movie%20poster%20Wolf%20Warrior%20style%2C%20soldier%20in%20tactical%20gear%20standing%20heroically%20with%20explosion%20background%2C%20intense%20cinematic%20lighting%20with%20orange%20and%20dark%20tones%2C%20dramatic%20composition%2C%20professional%20movie%20poster%20aesthetic&width=400&height=600&seq=movie-1-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20scene%20with%20military%20forces%20in%20desert%20landscape%2C%20helicopters%20flying%20overhead%2C%20dramatic%20sunset%20sky%20with%20orange%20and%20red%20clouds%2C%20cinematic%20wide%20angle%20shot&width=800&height=450&seq=movie-1-cover&orientation=landscape',
    isHot: true,
    isNew: true,
    isFeatured: true,
    tags: ['动作', '军事', '热血', '爱国'],
    releaseDate: '2026-06-15',
  },
  {
    id: 'movie-2',
    title: '流浪地球3：新家园',
    originalTitle: 'The Wandering Earth 3: New Home',
    year: 2026,
    category: '科幻片',
    categorySlug: 'scifi',
    rating: 9.1,
    duration: '156分钟',
    region: '中国大陆',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '赵今麦'],
    description: '地球抵达新星系后，人类面临着前所未有的挑战。未知的外星文明、新星球的神秘力量，以及地球内部的能源危机，让人类的命运再次悬于一线。航天员刘培强和科学家团队必须找到拯救地球的终极方案。',
    descriptionHtml: '<p>地球抵达新星系后，人类面临着前所未有的挑战。未知的外星文明、新星球的神秘力量，以及地球内部的能源危机，让人类的命运再次悬于一线。</p><p>作为中国科幻电影的巅峰之作，流浪地球3在视觉效果上达到了全新高度。影片使用了最先进的虚拟拍摄和特效技术，呈现出了令人叹为观止的宇宙奇观。</p><p>航天员刘培强和科学家团队必须找到拯救地球的终极方案，一场关乎全人类命运的冒险就此展开。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%2C%20massive%20planetary%20engine%20glowing%20blue%20against%20dark%20space%20background%2C%20Earth%20silhouette%20with%20thrusters%2C%20futuristic%20Chinese%20design%20elements%2C%20epic%20cosmic%20scale&width=400&height=600&seq=movie-2-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=Futuristic%20space%20station%20interior%20with%20astronauts%2C%20massive%20holographic%20displays%20showing%20galaxy%20maps%2C%20blue%20ambient%20lighting%20with%20warm%20accent%20lights%2C%20cinematic%20sci-fi%20atmosphere&width=800&height=450&seq=movie-2-cover&orientation=landscape',
    isHot: true,
    isNew: true,
    isFeatured: true,
    tags: ['科幻', '太空', '灾难', '史诗'],
    releaseDate: '2026-07-20',
  },
  {
    id: 'movie-3',
    title: '独行月球2：火星救援',
    originalTitle: 'Moon Man 2: Mars Rescue',
    year: 2026,
    category: '喜剧片',
    categorySlug: 'comedy',
    rating: 8.3,
    duration: '118分钟',
    region: '中国大陆',
    director: '张吃鱼',
    actors: ['沈腾', '马丽', '艾伦', '常远'],
    description: '独孤月本以为自己是月球上最后一个人，没想到火星上还困着一群宇航员。当他收到来自火星的求救信号后，一场横跨地月火三球的爆笑救援行动就此展开。沈腾马丽再度联手，笑料升级。',
    descriptionHtml: '<p>独孤月本以为自己是月球上最后一个人，没想到火星上还困着一群宇航员。当他收到来自火星的求救信号后，一场横跨地月火三球的爆笑救援行动就此展开。</p><p>沈腾马丽再度联手，笑料全面升级。影片在保留前作幽默风格的同时，加入了更多科幻元素和视觉奇观，让观众在捧腹大笑的同时也能享受视觉盛宴。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20movie%20poster%2C%20funny%20astronaut%20in%20spacesuit%20on%20Mars%20surface%2C%20comedic%20expression%2C%20red%20Martian%20landscape%2C%20bright%20warm%20lighting%2C%20playful%20movie%20poster%20design&width=400&height=600&seq=movie-3-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=Astronaut%20on%20red%20Mars%20surface%20making%20funny%20pose%2C%20dusty%20red%20landscape%20with%20rocks%2C%20bright%20sunlight%2C%20playful%20and%20humorous%20atmosphere&width=800&height=450&seq=movie-3-cover&orientation=landscape',
    isHot: true,
    isNew: false,
    isFeatured: true,
    tags: ['喜剧', '科幻', '搞笑', '沈腾'],
    releaseDate: '2026-05-01',
  },
  {
    id: 'movie-4',
    title: '红海行动2：深海危机',
    originalTitle: 'Operation Red Sea 2: Deep Crisis',
    year: 2026,
    category: '动作片',
    categorySlug: 'action',
    rating: 8.5,
    duration: '138分钟',
    region: '中国大陆',
    director: '林超贤',
    actors: ['张译', '黄景瑜', '海清', '杜江'],
    description: '蛟龙突击队接到紧急任务，一艘中国远洋货轮在索马里海域被海盗劫持。队员们必须在有限时间内完成解救任务，同时还要面对深海潜艇的威胁。一场惊心动魄的海上反恐行动全面展开。',
    descriptionHtml: '<p>蛟龙突击队接到紧急任务，一艘中国远洋货轮在索马里海域被海盗劫持。队员们必须在有限时间内完成解救任务，同时还要面对深海潜艇的威胁。</p><p>导演林超贤再次挑战动作电影极限，深海潜艇战斗场景实拍结合顶级特效，呈现出震撼的视觉效果。每一场动作戏都经过精心设计，让观众肾上腺素飙升。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20military%20action%20movie%20poster%2C%20naval%20special%20forces%20team%20in%20tactical%20gear%20on%20warship%20deck%2C%20dramatic%20ocean%20waves%2C%20stormy%20sky%2C%20intense%20cinematic%20lighting&width=400&height=600&seq=movie-4-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=Naval%20warship%20cutting%20through%20stormy%20ocean%20waves%2C%20dramatic%20dark%20sky%20with%20lightning%2C%20special%20forces%20soldiers%20in%20tactical%20gear%2C%20cinematic%20wide%20shot&width=800&height=450&seq=movie-4-cover&orientation=landscape',
    isHot: true,
    isNew: true,
    isFeatured: false,
    tags: ['动作', '军事', '海军', '反恐'],
    releaseDate: '2026-08-01',
  },
  {
    id: 'movie-5',
    title: '三体：黑暗森林',
    originalTitle: 'The Three-Body Problem: Dark Forest',
    year: 2026,
    category: '科幻片',
    categorySlug: 'scifi',
    rating: 8.9,
    duration: '145分钟',
    region: '中国大陆',
    director: '张艺谋',
    actors: ['易烊千玺', '张译', '陈道明', '周迅'],
    description: '面壁者罗辑发现了黑暗森林法则，宇宙文明之间的残酷真相被揭开。为了对抗三体文明的入侵，人类启动了面壁计划。然而，真正的威胁可能不仅仅来自外星文明——人类自身之间的博弈才更加危险。',
    descriptionHtml: '<p>面壁者罗辑发现了黑暗森林法则，宇宙文明之间的残酷真相被揭开。为了对抗三体文明的入侵，人类启动了面壁计划。</p><p>影片改编自刘慈欣同名科幻巨著，由张艺谋导演倾力打造。宏大的宇宙观、深刻的哲学思辨，以及震撼的视觉呈现，让这部电影成为2026年最受瞩目的科幻作品。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20movie%20poster%2C%20mysterious%20dark%20forest%20with%20cosmic%20elements%2C%20abstract%20geometric%20patterns%2C%20minimalist%20yet%20profound%20design%2C%20deep%20space%20colors%20with%20gold%20accents&width=400&height=600&seq=movie-5-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=Abstract%20cosmic%20scene%20with%20dark%20forest%20silhouette%2C%20stars%20and%20nebula%20in%20background%2C%20mysterious%20atmosphere%2C%20philosophical%20visual%2C%20high%20art%20sci-fi%20aesthetic&width=800&height=450&seq=movie-5-cover&orientation=landscape',
    isHot: true,
    isNew: true,
    isFeatured: true,
    tags: ['科幻', '刘慈欣', '哲学', '宇宙'],
    releaseDate: '2026-10-01',
  },
  {
    id: 'movie-6',
    title: '飞驰人生3：极速巅峰',
    originalTitle: 'Pegasus 3: Speed Summit',
    year: 2026,
    category: '喜剧片',
    categorySlug: 'comedy',
    rating: 7.9,
    duration: '112分钟',
    region: '中国大陆',
    director: '韩寒',
    actors: ['沈腾', '尹正', '黄景瑜', '范丞丞'],
    description: '张驰再次复出，这一次他要挑战的是世界拉力锦标赛。面对国际顶级车手的竞争和赛场上层出不穷的意外状况，这位老车手用他独特的幽默和智慧，上演了一出出令人捧腹又热血沸腾的好戏。',
    descriptionHtml: '<p>张驰再次复出，这一次他要挑战的是世界拉力锦标赛。面对国际顶级车手的竞争和赛场上层出不穷的意外状况，这位老车手用他独特的幽默和智慧，上演了一出出令人捧腹又热血沸腾的好戏。</p><p>韩寒导演的飞驰人生系列第三部，在延续前作热血赛车风格的同时，加入了更多国际元素和爆笑桥段。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20racing%20movie%20poster%2C%20vintage%20race%20car%20drifting%20on%20track%20with%20dust%20and%20smoke%2C%20warm%20sunset%20lighting%2C%20dynamic%20action%20composition&width=400&height=600&seq=movie-6-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=Racing%20car%20drifting%20on%20professional%20track%2C%20dust%20clouds%20and%20tire%20smoke%2C%20dramatic%20sunset%20sky%20with%20golden%20light%2C%20action%20packed%20scene&width=800&height=450&seq=movie-6-cover&orientation=landscape',
    isHot: false,
    isNew: true,
    isFeatured: false,
    tags: ['喜剧', '赛车', '热血', '励志'],
    releaseDate: '2026-04-28',
  },
  {
    id: 'movie-7',
    title: '你的名字2：时空重逢',
    originalTitle: 'Your Name 2: Spacetime Reunion',
    year: 2026,
    category: '爱情片',
    categorySlug: 'romance',
    rating: 8.4,
    duration: '108分钟',
    region: '日本',
    director: '新海诚',
    actors: ['神木隆之介', '上白石萌音'],
    description: '在东京生活的少年和乡下少女再次通过梦境交换了身体。这一次，他们不仅要面对时空的距离，还要揭开一个关乎两个世界命运的秘密。一段跨越时空的爱恋，再次触动人心。',
    descriptionHtml: '<p>在东京生活的少年和乡下少女再次通过梦境交换了身体。这一次，他们不仅要面对时空的距离，还要揭开一个关乎两个世界命运的秘密。</p><p>新海诚导演再度出手，延续了前作唯美浪漫的风格，画面精美绝伦，每一帧都是一幅艺术品。一段跨越时空的爱恋，再次触动人心。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20style%2C%20two%20young%20characters%20reaching%20toward%20each%20other%20across%20starry%20sky%2C%20beautiful%20pastel%20colors%2C%20dreamy%20romantic%20atmosphere&width=400&height=600&seq=movie-7-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20style%20landscape%20with%20starry%20night%20sky%2C%20city%20lights%20in%20distance%2C%20two%20silhouettes%20on%20hilltop%2C%20dreamy%20romantic%20atmosphere%2C%20soft%20pastel%20colors&width=800&height=450&seq=movie-7-cover&orientation=landscape',
    isHot: true,
    isNew: false,
    isFeatured: false,
    tags: ['爱情', '动画', '奇幻', '治愈'],
    releaseDate: '2026-02-14',
  },
  {
    id: 'movie-8',
    title: '中邪3：古寨迷踪',
    originalTitle: 'The Possessed 3: Lost Village',
    year: 2026,
    category: '恐怖片',
    categorySlug: 'horror',
    rating: 7.6,
    duration: '98分钟',
    region: '中国大陆',
    director: '马凯',
    actors: ['张子枫', '朱一龙', '王圣迪'],
    description: '一群大学生前往西南山区古寨进行民俗考察，却意外唤醒了沉睡百年的邪灵。当夜幕降临，古寨中诡异的事件接连发生。伪纪录片式的拍摄手法让恐怖感更加真实，令人毛骨悚然。',
    descriptionHtml: '<p>一群大学生前往西南山区古寨进行民俗考察，却意外唤醒了沉睡百年的邪灵。当夜幕降临，古寨中诡异的事件接连发生。</p><p>伪纪录片式的拍摄手法让恐怖感更加真实，每一个镜头都令人毛骨悚然。影片深入挖掘了中国民间恐怖传说，呈现出独特的东方恐怖美学。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20horror%20movie%20poster%2C%20eerie%20ancient%20village%20at%20night%20with%20fog%2C%20mysterious%20figure%20shadow%2C%20dark%20and%20creepy%20atmosphere%2C%20subtle%20red%20accents&width=400&height=600&seq=movie-8-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=Creepy%20ancient%20Chinese%20village%20at%20night%2C%20thick%20fog%20rolling%20through%20empty%20streets%2C%20dim%20lantern%20light%2C%20ominous%20shadows%2C%20horror%20atmosphere&width=800&height=450&seq=movie-8-cover&orientation=landscape',
    isHot: false,
    isNew: true,
    isFeatured: false,
    tags: ['恐怖', '惊悚', '民俗', '悬疑'],
    releaseDate: '2026-09-15',
  },
  {
    id: 'movie-9',
    title: '哪吒2：封神之战',
    originalTitle: 'Nezha 2: Battle of the Gods',
    year: 2026,
    category: '动画片',
    categorySlug: 'animation',
    rating: 9.0,
    duration: '122分钟',
    region: '中国大陆',
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨'],
    description: '哪吒重生后，发现天庭正酝酿一场针对人间的巨大阴谋。为保护陈塘关百姓，哪吒联合敖丙，与各路神仙展开了一场惊天动地的封神之战。国漫巅峰之作，画面与故事全面升级。',
    descriptionHtml: '<p>哪吒重生后，发现天庭正酝酿一场针对人间的巨大阴谋。为保护陈塘关百姓，哪吒联合敖丙，与各路神仙展开了一场惊天动地的封神之战。</p><p>国漫巅峰之作强势归来！画面质量全面升级，打斗场面更加流畅震撼，故事深度和情感表达也达到了新的高度。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%2C%20young%20warrior%20with%20fire%20wheels%20and%20red%20ribbon%2C%20dynamic%20fighting%20pose%2C%20traditional%20Chinese%20art%20style%2C%20vibrant%20red%20and%20gold%20colors&width=400&height=600&seq=movie-9-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20battle%20scene%20with%20gods%20and%20mythical%20creatures%2C%20traditional%20Chinese%20architecture%2C%20dramatic%20sky%20with%20fire%20and%20clouds%2C%20vibrant%20colors&width=800&height=450&seq=movie-9-cover&orientation=landscape',
    isHot: true,
    isNew: true,
    isFeatured: true,
    tags: ['动画', '神话', '国漫', '热血'],
    releaseDate: '2026-07-11',
  },
  {
    id: 'movie-10',
    title: '速度与激情12：终局',
    originalTitle: 'Fast & Furious 12: Endgame',
    year: 2026,
    category: '动作片',
    categorySlug: 'action',
    rating: 7.8,
    duration: '142分钟',
    region: '美国',
    director: '路易斯·莱特里尔',
    actors: ['范·迪塞尔', '杰森·斯坦森', '道恩·强森'],
    description: '唐老大和他的家人们面临最强大的敌人——一个掌握全球监控系统的神秘组织。从东京到迪拜，从里约到南极，全球飙车的终极决战即将打响。速度与激情系列的完结篇，不容错过。',
    descriptionHtml: '<p>唐老大和他的家人们面临最强大的敌人——一个掌握全球监控系统的神秘组织。从东京到迪拜，从里约到南极，全球飙车的终极决战即将打响。</p><p>作为速度与激情系列的完结篇，本片集结了系列最强的演员阵容和最震撼的动作场面。每一场飙车戏都突破极限。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Hollywood%20action%20movie%20poster%2C%20supercars%20racing%20through%20city%20street%20with%20explosions%2C%20dramatic%20night%20scene%2C%20neon%20lights%2C%20intense%20action%20composition&width=400&height=600&seq=movie-10-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=Supercars%20racing%20through%20neon-lit%20city%20at%20night%2C%20dramatic%20skyscrapers%20background%2C%20motion%20blur%20effect%2C%20high%20octane%20action%20scene%2C%20cinematic%20night%20photography&width=800&height=450&seq=movie-10-cover&orientation=landscape',
    isHot: true,
    isNew: false,
    isFeatured: false,
    tags: ['动作', '赛车', '冒险', '系列完结'],
    releaseDate: '2026-05-23',
  },
  {
    id: 'movie-11',
    title: '后来的我们2：再见青春',
    originalTitle: 'Us and Them 2: Farewell Youth',
    year: 2026,
    category: '爱情片',
    categorySlug: 'romance',
    rating: 7.5,
    duration: '105分钟',
    region: '中国大陆',
    director: '刘若英',
    actors: ['井柏然', '周冬雨', '田壮壮'],
    description: '十年后，林见清和方小晓在异国他乡再次相遇。曾经的遗憾、未说出口的话，以及那段回不去的青春，都在这座陌生的城市里重新浮现。他们能否放下过去，勇敢面对现在？',
    descriptionHtml: '<p>十年后，林见清和方小晓在异国他乡再次相遇。曾经的遗憾、未说出口的话，以及那段回不去的青春，都在这座陌生的城市里重新浮现。</p><p>刘若英导演再次执导爱情电影，延续了前作细腻真挚的情感表达。影片在异国美景的映衬下，讲述了一个关于遗憾、成长与和解的故事。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20romance%20movie%20poster%2C%20couple%20silhouette%20against%20sunset%20city%20skyline%2C%20warm%20golden%20lighting%2C%20nostalgic%20and%20emotional%20atmosphere%2C%20soft%20focus&width=400&height=600&seq=movie-11-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=City%20skyline%20at%20sunset%20with%20warm%20golden%20light%2C%20two%20people%20on%20rooftop%20overlooking%20city%2C%20nostalgic%20emotional%20atmosphere%2C%20soft%20warm%20colors&width=800&height=450&seq=movie-11-cover&orientation=landscape',
    isHot: false,
    isNew: false,
    isFeatured: false,
    tags: ['爱情', '青春', '怀旧', '文艺'],
    releaseDate: '2026-03-08',
  },
  {
    id: 'movie-12',
    title: '疾速追杀5：终极制裁',
    originalTitle: 'John Wick 5: Final Sanction',
    year: 2026,
    category: '动作片',
    categorySlug: 'action',
    rating: 8.6,
    duration: '135分钟',
    region: '美国',
    director: '查德·斯塔赫斯基',
    actors: ['基努·里维斯', '甄子丹', '真田广之'],
    description: '约翰·威克面对高桌会的终极追杀令，必须在72小时内击败所有前来取他人头的杀手。从巴黎地下墓穴到东京霓虹街头，一场全球范围内的生死追杀拉开帷幕。动作电影的巅峰之作。',
    descriptionHtml: '<p>约翰·威克面对高桌会的终极追杀令，必须在72小时内击败所有前来取他人头的杀手。从巴黎地下墓穴到东京霓虹街头，一场全球范围内的生死追杀拉开帷幕。</p><p>本片集结了全球顶级动作明星，基努·里维斯、甄子丹和真田广之的强强联手，呈现出令人窒息的格斗场面。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Hollywood%20action%20movie%20poster%2C%20lone%20gunman%20in%20sleek%20suit%20with%20weapon%2C%20dark%20urban%20background%2C%20neon%20accents%2C%20intense%20and%20stylish%20composition&width=400&height=600&seq=movie-12-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=Dark%20urban%20alley%20at%20night%20with%20neon%20signs%20reflecting%20on%20wet%20pavement%2C%20lone%20figure%20walking%2C%20moody%20atmospheric%20lighting%2C%20modern%20noir%20cinematography&width=800&height=450&seq=movie-12-cover&orientation=landscape',
    isHot: true,
    isNew: false,
    isFeatured: false,
    tags: ['动作', '枪战', '格斗', '犯罪'],
    releaseDate: '2026-01-18',
  },
  {
    id: 'movie-13',
    title: '长津湖3：冰雪长津',
    originalTitle: 'The Battle at Lake Changjin 3',
    year: 2026,
    category: '战争片',
    categorySlug: 'war',
    rating: 9.2,
    duration: '168分钟',
    region: '中国大陆',
    director: '陈凯歌',
    actors: ['吴京', '易烊千玺', '段奕宏', '朱亚文'],
    description: '抗美援朝战争进入关键阶段，志愿军战士们在极寒天气下坚守阵地。零下四十度的严寒、匮乏的物资、悬殊的装备差距，都未能动摇他们保家卫国的决心。一部荡气回肠的战争史诗。',
    descriptionHtml: '<p>抗美援朝战争进入关键阶段，志愿军战士们在极寒天气下坚守阵地。零下四十度的严寒、匮乏的物资、悬殊的装备差距，都未能动摇他们保家卫国的决心。</p><p>作为长津湖系列的收官之作，本片以更加宏大的视角展现了这场伟大战争的全貌。每一个镜头都充满力量，每一个角色都令人动容。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20poster%2C%20soldiers%20in%20winter%20combat%20gear%20standing%20strong%20in%20snow%20storm%2C%20dramatic%20lighting%2C%20epic%20historical%20composition%2C%20cold%20blue%20tones&width=400&height=600&seq=movie-13-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=Epic%20winter%20battlefield%20scene%20with%20soldiers%20advancing%20through%20heavy%20snow%2C%20dramatic%20mountain%20landscape%2C%20cold%20blue%20atmosphere%20with%20explosions%20lighting%20sky&width=800&height=450&seq=movie-13-cover&orientation=landscape',
    isHot: true,
    isNew: true,
    isFeatured: false,
    tags: ['战争', '历史', '爱国', '史诗'],
    releaseDate: '2026-10-25',
  },
  {
    id: 'movie-14',
    title: '消失的她2：迷雾追踪',
    originalTitle: 'Lost in the Stars 2: Fog Chase',
    year: 2026,
    category: '恐怖片',
    categorySlug: 'horror',
    rating: 8.0,
    duration: '108分钟',
    region: '中国大陆',
    director: '崔睿',
    actors: ['朱一龙', '倪妮', '文咏珊'],
    description: '一位年轻女子在泰国度假时神秘失踪，她的丈夫在寻找妻子的过程中，逐渐发现了一个令人震惊的真相。每一个线索都指向一个精心设计的陷阱，真相远比想象中更加可怕。',
    descriptionHtml: '<p>一位年轻女子在泰国度假时神秘失踪，她的丈夫在寻找妻子的过程中，逐渐发现了一个令人震惊的真相。每一个线索都指向一个精心设计的陷阱。</p><p>影片延续了前作悬疑反转的风格，剧情更加扑朔迷离，反转更加出人意料。东南亚的异域风情与悬疑氛围完美融合。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20suspense%20thriller%20movie%20poster%2C%20mysterious%20woman%20silhouette%20in%20tropical%20setting%2C%20foggy%20atmosphere%2C%20dark%20and%20moody%20lighting&width=400&height=600&seq=movie-14-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20tropical%20beach%20at%20dusk%20with%20fog%20rolling%20in%2C%20lone%20figure%20standing%20by%20water%2C%20moody%20and%20suspenseful%20atmosphere&width=800&height=450&seq=movie-14-cover&orientation=landscape',
    isHot: false,
    isNew: true,
    isFeatured: false,
    tags: ['悬疑', '惊悚', '反转', '犯罪'],
    releaseDate: '2026-06-30',
  },
  {
    id: 'movie-15',
    title: '熊出没·重返地球2',
    originalTitle: 'Boonie Bears: Back to Earth 2',
    year: 2026,
    category: '动画片',
    categorySlug: 'animation',
    rating: 7.8,
    duration: '95分钟',
    region: '中国大陆',
    director: '林汇达',
    actors: ['张伟', '张秉君', '谭笑'],
    description: '熊大熊二和光头强再次踏上太空冒险之旅！这次他们要前往一颗神秘的星球，寻找能够拯救森林的神奇种子。一路上，他们遇到了各种有趣的外星生物，展开了一段欢乐又刺激的旅程。',
    descriptionHtml: '<p>熊大熊二和光头强再次踏上太空冒险之旅！这次他们要前往一颗神秘的星球，寻找能够拯救森林的神奇种子。</p><p>作为国产动画的合家欢代表，熊出没系列一直深受大小朋友的喜爱。本片在画面和故事上全面升级，更加精彩的冒险和更温暖的情感。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20movie%20poster%2C%20cute%20bear%20characters%20in%20space%20suits%20with%20colorful%20alien%20planets%20background%2C%20bright%20and%20cheerful%20colors%2C%20family%20friendly&width=400&height=600&seq=movie-15-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=Colorful%20alien%20planet%20landscape%20with%20cute%20animated%20characters%20exploring%2C%20vibrant%20plants%2C%20bright%20sunny%20sky%2C%20cheerful%20family%20animation%20style&width=800&height=450&seq=movie-15-cover&orientation=landscape',
    isHot: false,
    isNew: false,
    isFeatured: false,
    tags: ['动画', '喜剧', '冒险', '合家欢'],
    releaseDate: '2026-01-22',
  },
  {
    id: 'movie-16',
    title: '封神第二部：战火西岐',
    originalTitle: 'Creation of the Gods II: Battle of Xiqi',
    year: 2026,
    category: '战争片',
    categorySlug: 'war',
    rating: 8.8,
    duration: '150分钟',
    region: '中国大陆',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适'],
    description: '殷商大军兵临西岐城下，姜子牙率领西岐军民展开了一场惊天地泣鬼神的保卫战。各路神仙纷纷登场，封神大战全面爆发。中国神话史诗的巅峰呈现，视觉效果震撼人心。',
    descriptionHtml: '<p>殷商大军兵临西岐城下，姜子牙率领西岐军民展开了一场惊天地泣鬼神的保卫战。各路神仙纷纷登场，封神大战全面爆发。</p><p>乌尔善导演倾力打造的中国神话史诗，在视觉呈现上达到了全新高度。宏大的战争场面、精美的神话元素，以及深刻的人性探讨。</p>',
    posterUrl: 'https://readdy.ai/api/search-image?query=Chinese%20epic%20fantasy%20movie%20poster%2C%20ancient%20warriors%20and%20mythical%20creatures%20in%20battle%2C%20dramatic%20sky%20with%20divine%20light%2C%20traditional%20Chinese%20art%20elements&width=400&height=600&seq=movie-16-poster&orientation=portrait',
    coverUrl: 'https://readdy.ai/api/search-image?query=Epic%20ancient%20Chinese%20battle%20scene%20with%20thousands%20of%20warriors%2C%20mythical%20creatures%20flying%2C%20dramatic%20lighting%2C%20traditional%20architecture%2C%20grand%20scale&width=800&height=450&seq=movie-16-cover&orientation=landscape',
    isHot: true,
    isNew: true,
    isFeatured: true,
    tags: ['神话', '战争', '史诗', '奇幻'],
    releaseDate: '2026-07-25',
  },
];

export function getMoviesByCategory(slug: string): Movie[] {
  return movies.filter((m) => m.categorySlug === slug);
}

export function getMovieById(id: string): Movie | undefined {
  return movies.find((m) => m.id === id);
}

export function getHotMovies(): Movie[] {
  return movies.filter((m) => m.isHot);
}

export function getNewMovies(): Movie[] {
  return movies.filter((m) => m.isNew);
}

export function getFeaturedMovies(): Movie[] {
  return movies.filter((m) => m.isFeatured);
}

export function getRelatedMovies(movie: Movie, limit: number = 6): Movie[] {
  return movies
    .filter((m) => m.id !== movie.id && m.categorySlug === movie.categorySlug)
    .slice(0, limit);
}

export function getCategoryBySlug(slug: string): MovieCategory | undefined {
  return movieCategories.find((c) => c.slug === slug);
}

export const siteInfo = {
  name: '97影院',
  tagline: '电影大全免费在线观看',
  description: '97影院为您提供最新电影、热播电影、经典电影免费在线观看服务。涵盖动作片、喜剧片、科幻片、爱情片、恐怖片、动画片等多种类型，高清蓝光画质，播放流畅不卡顿。',
  url: 'https://www.97cinema.com',
  email: 'contact@97cinema.com',
  phone: '400-888-9797',
  address: '北京市朝阳区建国路97号',
  icp: '京ICP备2024000001号',
  founded: 2018,
  totalMovies: 10000,
  dailyVisitors: 500000,
  copyright: '© 2018-2026 97影院 版权所有',
};